import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>,
);

// PWA: capture install prompt + register the service worker.
window.__sliplyInstall = null;
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  window.__sliplyInstall = e;
  window.dispatchEvent(new Event("sliply-installable"));
});
window.addEventListener("appinstalled", () => {
  window.__sliplyInstall = null;
  window.dispatchEvent(new Event("sliply-installed"));
});

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").then((reg) => {
      const notify = (worker) => {
        window.__sliplyWaiting = worker;
        window.dispatchEvent(new Event("sliply-update-ready"));
      };
      // A worker is already waiting (update installed on a previous visit).
      if (reg.waiting && navigator.serviceWorker.controller) notify(reg.waiting);
      // A new worker starts installing.
      reg.addEventListener("updatefound", () => {
        const nw = reg.installing;
        if (!nw) return;
        nw.addEventListener("statechange", () => {
          if (nw.state === "installed" && navigator.serviceWorker.controller) notify(nw);
        });
      });
      // Check for updates on tab focus and hourly.
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") reg.update().catch(() => {});
      });
      setInterval(() => reg.update().catch(() => {}), 60 * 60 * 1000);
    }).catch(() => {});
  });

  // When the new worker takes control, reload once to load the fresh bundle.
  let refreshing = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });
}

